<template>
	<v-list-item class="layoutTile layoutTile--nav layoutTile-nav"
				 :class="{'layoutTile--column': column}"
				 active-class="layoutTile--active"
				 :href="href"
				 :target="target"
				 :to="to"
				 v-on="on"
				 ripple>
		<v-icon class="layoutTile-nav-icon">{{icon}}</v-icon>
		<v-list-item-content>
			<v-list-item-title class="layoutTile-nav-label text-body-2 text-uppercase ml-2">{{label}}</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class LayoutNavItem extends Vue {
	@Prop() icon: string;
	@Prop() href: string;
	@Prop() target: string;
	@Prop() to: string;
	@Prop() label: string;
	@Prop({ type: Boolean, default: false }) column: boolean;
	on: object = {};

	mounted() {
		this.on = this.$vnode.componentOptions.listeners;
	}
}
</script>

<style lang="scss">
	.layoutTile {
		&--active {
			text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
		}

		.v-application &,
		&.success,
		&.info,
		&.warning,
		&.error {
			color: #fff;
		}
	}

	.layoutTile-nav-avatar {
		min-width: 40px;
	}

	.layoutTile-nav-icon {
		.layoutTile--active & {
			color: var(--v-secondary-base);
		}

		.layoutTile--column & {
			line-height: 20px;
			margin-bottom: 2px;
		}
	}

	.layoutTile-nav-label {
		.layoutTile--active & {
			font-weight: bold;
		}

		.layoutTile--column & {
			margin-left: 0 !important;
			text-align: center;
			line-height: 16px;
			height: 16px;
		}
	}

	.v-list__tile {
		.layoutTile--column & {
			padding: 0.25em 0;
			display: flex;
			flex-direction: column;
		}
	}
</style>